import React from 'react';

export const DisableAddToHomeScreen = () => {
  return (
    <script
      key="disable-add-to-home-screen"
      id="disable-add-to-home-screen"
      dangerouslySetInnerHTML={{
        __html: `
        (function(){
          window.addEventListener(
            'beforeinstallprompt',
            function(e) {
              e.preventDefault();
            },
            {once: true}
          );
        })()
      `,
      }}
    />
  );
};
